export default "__VITE_ASSET__K1daVVNYU_lXF$FdA5v55g__ 200w, __VITE_ASSET__7PUm3F_uVf$21BIFLSklvQ__ 500w, __VITE_ASSET__cLZLOsSELI_GmwKcVOKKRw__ 1000w";